module.exports = __webpack_public_path__ + "img/photo02.9b6f0650.jpg";